import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
.ScheduleCard {
  position: relative;
  width: 100%;
  height: 132px;
  margin-bottom: 12px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background: ${colors.elevatedBg};
}

.ScheduleCard.on-now {
  padding: 1px;
  background: linear-gradient(180deg, #FF6B00 16.67%, #C12A26 83.33%);
}

.ScheduleCard-inner-wrapper {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: ${colors.elevatedBg};
}

.schedule {
  position: absolute;
  top: 4px;
  width: 56px;
  height: 18px;
  top: 8px;
  right: 8px;
  padding: 2px 5px 5px 5px;
  border-radius: 2px;
}

.schedule.on-now {
  background: ${colors.red}
}

.schedule.on-next {
  background: ${colors.ctvBg}
}

.pre-title {
  font-family: Source Sans Pro;
  font-size: 13px;
  font-weight: 600;
  line-height: 10px;
  text-align: center;
  display: flex;
  gap: 4px;
  align-items: center;
  color: ${colors.primaryText};
  width: 100%;
  height: 100%;
}

.title {
  color: ${colors.primaryText};
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
  height: auto;
  display: flex;
  flex-wrap: wrap;
}

.title-main{
  margin-right: 0.25rem;
}

.title-main.psports{
  color: yellow;
}

.title-subtitle {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.summary {
  margin-top: 2px;
  color: ${colors.primaryText};
  font-size: 16px;
  font-weight: 400;
  line-height: 20.11px;
  width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.main-content {
  padding: 8px;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.text-wrapper {
  width: 80%;
}

.time {
  color: ${colors.secondaryText};
  font-size: 16px;
  font-weight: 400;
  line-height: 25px;
}

.more-episodes {
  color: ${colors.darkPurple};
  font-weight: bold;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-top: 42px;
}

.card-image {
  max-width: 87px !important;
  min-width: 87px !important;
  height: 116px;
  display: block;
  margin-right: 16px;
  object-fit: cover;
  border-radius: 8px !important;
  overflow: hidden;
}

.Image :global(img) {
  object-fit: cover;
}

@media (max-width: 390px) {
  .ScheduleCard {
    height: 132px;
    width: 100%;
    margin-bottom: 12px;
  }
  .summary {
    width: 100%;
  }
}

@media (min-width: 391px) {
  .ScheduleCard {
    height: 132px;
    margin-bottom: 8px;
    width: 86%;
    min-width: 86%;
  }
  .schedule {
    position: absolute;
    top: 4px;
    width: 56px;
    height: 20px;
    top: 8px;
    gap: 4px;
    border-radius: 2px;
  }
  .summary {
    width: 100%;
  }
}
@media (min-width: 450px) {
  .ScheduleCard {
    width: 408px;
    min-width: 408px;
  }
}
@media (min-width: 1024px) and (max-width: 1280px) {
  .ScheduleCard {
    height: 132px;
    margin-bottom: 12px;
  }
  .summary {
    width: 98%;
  }
  .schedule {
    position: absolute;
    top: 8px;
  }
}

@media (min-width: 1280px) and (max-width: 1366px) {
  .ScheduleCard {
    height: 132px;
    margin-bottom: 12px;
  }
  .summary {
    width: 98%;
  }
  .schedule {
    position: absolute;
    top: 8px;
  }
}

@media (min-width: 1366px) and (max-width: 1600px) {
  .ScheduleCard {
    height: 132px;
    margin-bottom: 12px;
  }
  .summary {
    width: 98%;
  }
  .schedule {
    position: absolute;
    top: 8px;
  }
}

@media (min-width: 1600px) and (max-width: 1920px) {
  .ScheduleCard {
    height: 132px;
    margin-bottom: 12px;
  }
  .summary {
    width: 98%;
  }
  .schedule {
    position: absolute;
    top: 8px;
  }
}
`
